import {
  Directive,
  AfterViewInit,
  OnDestroy,
  Optional,
  Input,
  HostListener
} from '@angular/core';
import { Dropdown } from 'primeng/dropdown';

@Directive({
  selector: '[smartDropdown]'
})
export class SmartDropdownDirective implements AfterViewInit, OnDestroy {
  private inputEl: HTMLInputElement;
  private keydownHandler: any;
  private inputHandler: any;

  @Input() autoSelectMinLength: number = 0;
  @Input() smartDropdownSeparator: string = ' - ';

  constructor(@Optional() private dropdown: Dropdown) { }

  ngAfterViewInit() {
    this.dropdown?.onShow?.subscribe(() => {
      this.bindToFilterInput();
    });
  }

  // פוקוס על הדרופדאון יפתח את הרשימה ויעביר פוקוס לשדה חיפוש
  @HostListener('onFocus')
  @HostListener('click')
  onFocus() {
    if (!this.dropdown?.filter || this.dropdown?.editable || this.dropdown.overlayVisible) return;

    this.dropdown.show();

    const sub = this.dropdown.onShow.subscribe(() => {
      const input = this.dropdown?.filterViewChild?.nativeElement;
      input?.focus(); // מעביר את הפוקוס לשדה החיפוש
      sub.unsubscribe();
    });
  }


  private bindToFilterInput() {
    setTimeout(() => {
      this.inputEl = this.dropdown?.filterViewChild?.nativeElement;
      if (!this.inputEl) return;

      this.keydownHandler = (event: KeyboardEvent) => {
        const value = this.inputEl.value;

        // Enter → נסה לבחור ערך
        if (event.key === 'Enter') {
          this.dropdown.hide();
          setTimeout(() => this.focusNextField(), 50);
          event.preventDefault();
        }

        // Tab → סגור ועבור לשדה הבא
        if (event.key === 'Tab' && !event.shiftKey) {
          this.dropdown.hide();
          setTimeout(() => this.focusNextField(), 50);
          event.preventDefault();
        }

        // Shift+Tab → סגור ועבור לשדה הקודם
        if (event.key === 'Tab' && event.shiftKey) {
          this.dropdown.hide();
          setTimeout(() => this.focusPreviousField(), 50);
          event.preventDefault();
        }
      };

      this.inputEl.addEventListener('keydown', this.keydownHandler);

      // הקלדה חופשית → בחירה אוטומטית
      this.inputHandler = (event: Event) => {
        const value = (event.target as HTMLInputElement).value;
        if (value?.length >= this.autoSelectMinLength) {
          this.trySelectMatch(value);
        }
      };

      this.inputEl.addEventListener('input', this.inputHandler);
    }, 0);
  }


  // הפונקציה בוחרת ערך לפי הקלדה או לפי בחירה עם חצים, ומעבירה לפוקוס הבא
  // בוחרת ערך לפי מה שהמשתמש עומד עליו עם חיצים, או לפי התאמה של טקסט
  // בוחרת ערך מ-p-dropdown לפי מיקום נוכחי או הקלדה
  private trySelectMatch(rawValue: string, event?: KeyboardEvent) {
    const val = rawValue?.toLowerCase();
    if (!this.dropdown?.options?.length) return;

    const filterKeys = (this.dropdown.filterBy ?? this.dropdown.optionLabel)?.split(',')?.map(k => k.trim());

    // חיפוש האלמנט המסומן בתוך הרשימה של הדרופדאון הספציפי
    // const activeId = document.activeElement?.getAttribute('aria-activedescendant');
    // const activeItem = activeId ? document.getElementById(activeId) : null;
    // let currentHovered: any = null;

    // if (activeItem) {
    //   const hoveredText = activeItem.textContent?.trim()?.toLowerCase();
    //   const separator = this.smartDropdownSeparator;
    //   currentHovered = this.dropdown.options.find(option => {
    //     const combined = filterKeys
    //       .map(key => String(option[key] ?? '').trim().toLowerCase())
    //       .join(separator.toLowerCase());
    //     return combined === hoveredText;
    //   });
    // }

    // fallback – אם אין בחירה נוכחית, מחפש את ההתאמה לפי תחילת הערך
    const match =// !currentHovered && 
      this.dropdown.options.find(option =>
        filterKeys.some(key =>
          String(option[key] ?? '').toLowerCase().startsWith(val)
        )
      );

    const selected = //currentHovered || 
      match;

    if (selected) {
      this.dropdown.selectItem(event ?? new KeyboardEvent('keydown'), selected);
      this.dropdown.hide();
      setTimeout(() => this.focusNextField(), 50);
    }
  }


  private focusNextField() {
    const all = Array.from(
      document.querySelectorAll<HTMLElement>(
        'input, select, textarea, button, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(el => !el.hasAttribute('disabled') && el.tabIndex >= 0);

    const dropdownElement = this.dropdown?.el?.nativeElement;
    if (!dropdownElement) return;

    // מוצא את הדרופדאון עצמו ברשימת האלמנטים
    const index = all.findIndex(el => el === dropdownElement || dropdownElement.contains(el));

    if (index > -1 && index + 1 < all.length) {
      all[index + 1].focus();
    }
  }

  private focusPreviousField() {
    const all = Array.from(
      document.querySelectorAll<HTMLElement>(
        'input, select, textarea, button, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(el => !el.hasAttribute('disabled') && el.tabIndex >= 0);

    const dropdownElement = this.dropdown?.el?.nativeElement;
    if (!dropdownElement) return;

    // מוצא את הדרופדאון עצמו ברשימת האלמנטים
    const index = all.findIndex(el => el === dropdownElement || dropdownElement.contains(el));

    if (index > -1 && index + 1 < all.length) {
      all[index - 1].focus();
    }
  }


  ngOnDestroy() {
    if (this.inputEl && this.keydownHandler) {
      this.inputEl.removeEventListener('keydown', this.keydownHandler);
    }
    if (this.inputEl && this.inputHandler) {
      this.inputEl.removeEventListener('input', this.inputHandler);
    }
  }
}